import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import Translate from "../../../../utils/Translate";

// Components
import SalesNumberBox from "./SalesNumberBox";

const SalesRow = ({ canEdit, title, object, appendPin, removePin, marketLeader }) => {
  const [titleTxt, setTitleTxt] = useState("");
  const [isLeader, setIsLeader] = useState(false);
console.log(marketLeader)
  useEffect(() => {
    switch (title) {
      case "Nat":
        setTitleTxt(<Translate alias="Board" word="Nat" />);
        break;
      case "Int":
        setTitleTxt(<Translate alias="Board" word="Int" />);
        break;
      case "IntC1":
        setTitleTxt(<Translate alias="Board" word="IntC1" />);
        break;
      case "IntC2":
        setTitleTxt(<Translate alias="Board" word="IntC2" />);
        break;
      default:
        break;
    }
  }, [title]);

  useEffect(() => {
    const map = {
      Nat: "national",
      Int: "international",
      IntC1: "intercontinental1",
      IntC2: "intercontinental2",
    };
    
    setIsLeader(Array.isArray(marketLeader) && marketLeader.includes(map[title]));
  }, [marketLeader, title]);

  return (
    <Row className="sales-row-container align-items-center">
        <Col>
          <span className="sales-row-title" style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            {titleTxt}
            {isLeader && (
    <span
      style={{
        color: "#FFD700",
        fontSize: "1.6rem",
        textShadow: "0 0 8px rgba(255,215,0,0.9)",
        position: "absolute",    // <-- make it free-floating
        left: "-40px",           // <-- move it OUTSIDE
        zIndex: 9999             // <-- appear above layers
      }}
      title="Market Leader"
    >
      ⭐
    </span>
  )}
  
          </span>
        </Col>

      {object.map((value, index) => (
        <Col key={index}>
          <SalesNumberBox
            canEdit={canEdit}
            id={index}
            hasPin={value.pin}
            title={title}
            number={value.value}
            appendPin={appendPin}
            removePin={removePin}
          />
        </Col>
      ))}

      {object.length === 1 && (
        <>
          <Col></Col>
          <Col></Col>
          <Col></Col>
        </>
      )}

      {object.length === 2 && (
        <>
          <Col></Col>
          <Col></Col>
        </>
      )}
    </Row>
  );
};

export default SalesRow;
